import React, { Suspense, useEffect } from 'react';
import { Canvas } from '@react-three/fiber';
import { useDispatch, useSelector } from 'react-redux';
import debounce from 'lodash.debounce';

import { handleCloseforDoorWindows, setActiveBuildingWall } from '../../action';
import { const_var, params } from '../../redux/reducers/reducer';
// import WATERMARK_IMG from "../../assets/images/newWatermark/logo-sensei.svg";
import CanvasEnv from './CanvasEnv';
import Building from '../Building';
import CameraController from '../CameraController';
import * as cuComponent from "../../redux/reducers/componentReducer";
import VerticalSlider from '../BuildingCanvas/ChildComponent/VerticalSlider';
import HorizontalSlider from '../BuildingCanvas/ChildComponent/HorizontalSlider';
import ZoomInOut from '../BuildingCanvas/ChildComponent/ZoomInOut';
import BottomFooter from '../BuildingCanvas/ChildComponent/BottomFooter';
import UnderBottomFooter from '../BuildingCanvas/ChildComponent/UnderBottomFooter';

const NewCanvas = () => {
    const dispatch = useDispatch();
    const showThumb = useSelector(state=>state.reducer.showThumb)
    // const handlePointerUp = debounce(() => {
    //     if (const_var.controls !== undefined && !const_var.componentsMoving) {
    //         if (const_var.wallSelection.leanToWall == "select") {
    //             const currentAzimuthalAngle = const_var.controls.getAzimuthalAngle();
    //             const camAngle = (Math.atan((params.p_d / 2) / (params.p_w / 2)))

    //             if (currentAzimuthalAngle >= -(Math.PI / 2 - camAngle) && currentAzimuthalAngle < (Math.PI / 2 - camAngle)) {
    //                 if (params.cB_addStorage_check_right === true && params.p_f_w != "Close") {
    //                     dispatch(setActiveBuildingWall('c_b_r_s_f_w'));
    //                 } else if (params.cB_addStorage_check_left === true && params.p_f_w != "Close") {
    //                     dispatch(setActiveBuildingWall('c_b_l_s_f_w'));
    //                 } else {
    //                     dispatch(setActiveBuildingWall('c_b_f_w'));
    //                 }
    //             } else if (currentAzimuthalAngle >= (Math.PI / 2 - camAngle) && currentAzimuthalAngle < ((Math.PI / 2 - camAngle) + camAngle * 2)) {
    //                 dispatch(setActiveBuildingWall('c_b_r_w'));
    //             } else if (currentAzimuthalAngle >= -((Math.PI / 2 - camAngle) + camAngle * 2) && currentAzimuthalAngle < -(Math.PI / 2 - camAngle)) {
    //                 dispatch(setActiveBuildingWall('c_b_l_w'));
    //             } else {
    //                 if (params.cB_addStorage_check_right === true && params.p_b_w != "Close") {
    //                     dispatch(setActiveBuildingWall('c_b_r_s_b_w'));
    //                 } else if (params.cB_addStorage_check_left === true && params.p_b_w != "Close") {
    //                     dispatch(setActiveBuildingWall('c_b_l_s_b_w'));
    //                 } else {
    //                     dispatch(setActiveBuildingWall('c_b_b_w'));
    //                 }
    //             }
    //         }
    //     } 
    //     const_var.componentsMoving = false;
    // }, 100)

    const handlePointerDown = () => {
        if (const_var.controls !== undefined) {
            const_var.controls.target?.set(0, params.p_h / 2, 0);
        }
    }

    return (
     <div className="canvas-box-wrapper">
        <div className="canvas">
            <span className="side-icon"></span>
            <span className="side-icon"></span>
            <span className="side-icon"></span>
            <span className="side-icon"></span>
            {/* <img
                alt='overlay img'
                className="overlay-logo-image"
                src={`${process.env.REACT_APP_BASE_URL}${WATERMARK_IMG}`}
            /> */}
            <VerticalSlider/>
            <HorizontalSlider/>
            <ZoomInOut/>
            {!showThumb ? <BottomFooter/>: null}
            <UnderBottomFooter />
            <div id="canvas-container" >
                <Canvas
                    id='canvas'
                    gl={{ preserveDrawingBuffer: true }}  /* added gl parameter as capture photos was not working. */
                    camera={{
                        fov: "25",
                        near: 1,
                        far: 100000,
                        position: [-5, 0, -15],
                    }}
                    className='buildingcanvas'
                    onPointerDown={handlePointerDown}
                    // onPointerUp={handlePointerUp}
                >
                    <CanvasEnv />
                    <Suspense fallback={null}>
                        <Building />
                        <CameraController />
                    </Suspense>
                </Canvas>
            </div>
        </div>
     </div>
    )
}

export default NewCanvas